export const SEARCHBOX_SHOW                 = 'SEARCHBOX_SHOW';
export const SEARCHBOX_HIDE                 = 'SEARCHBOX_HIDE';
export const SEARCHBOX_SEARCH_REP           = 'SEARCHBOX_SEARCH_REP';
export const SEARCHBOX_SEARCH_REP_CLEAR     = 'SEARCHBOX_SEARCH_REP_CLEAR';


// WEBPACK FOOTER //
// ./app/constants/searchTypes.js